import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { faqs } from '../../data/faqs';
import { site } from '../../data/site';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const prefersReducedMotion = useReducedMotion();
  return <Section labelledBy="faq-title" bordered data-id="element-468" data-mp="205jsun3vwg5z">
      <Container data-id="element-469" data-mp="206coot1b1l9c">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-8" data-id="element-470" data-mp="206ux0o18rpxm">
          <div className="lg:col-span-4" data-id="element-471" data-mp="1m6jzx39c9f40">
            <Reveal data-id="element-472" data-mp="1m7v7zf9th90x">
              <h2 id="faq-title" className="max-w-[12ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-473" data-mp="1r4vflumbeju5">
                Questions we get asked.
              </h2>
              <p className="mt-6 max-w-[38ch] text-body text-muted" data-id="element-474" data-mp="3lhuybwlzru5n">
                Still unsure about something?{' '}
                <a href={`mailto:${site.email}`} className="text-accent underline decoration-accent/30 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-accent" data-id="element-475" data-mp="2neecskm5zost">
                  Email us
                </a>{' '}
                and you will get a real answer, not a sales call.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-476" data-mp="24hd3wophp4jl">
            <ul className="border-t border-hairline" data-id="element-477" data-mp="20g9r6b2qnoml">
              {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return <li key={faq.question} className="border-b border-hairline" data-id="element-478" data-mp="29gfwvas73kb7" data-mpi={index}>
                    <h3 data-id="element-479" data-mp="29iiwmmj5grt4">
                      <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="group flex w-full items-start justify-between gap-8 py-7 text-left" data-id="element-480" data-mp="3ptwo7vna5xx3">
                        <span className="max-w-[40ch] text-[20px] leading-[1.35] tracking-[-0.02em] text-ink" data-id="element-481" data-mp="5rbjltvylhmv">
                          {faq.question}
                        </span>
                        <PlusIcon size={20} aria-hidden="true" className={`mt-1 shrink-0 text-muted transition-transform duration-200 ease-editorial group-hover:text-ink ${isOpen ? 'rotate-45' : ''}`} data-id="element-482" data-mp="aobnpz990abc" />
                      </button>
                    </h3>
                    <AnimatePresence initial={false} data-id="element-483" data-mp="2qhk5gskry7et">
                      {isOpen && <motion.div id={`faq-panel-${index}`} initial={prefersReducedMotion ? false : {
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={prefersReducedMotion ? {
                    opacity: 0
                  } : {
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.23, 1, 0.32, 1]
                  }} className="overflow-hidden" data-id="element-484" data-mp="2qfprxzbu1hkr">
                          <p className="max-w-measure pb-8 pr-10 text-body text-muted" data-id="element-485" data-mp="24y9wrobnj9ce">
                            {faq.answer}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </Container>
    </Section>;
}